import { atom, getDefaultStore, useAtom } from 'jotai';
import { Singleton } from 'Core_Helpers/Singleton';
import { IStateStore } from 'Core_Helpers/IStateStore';
import reduxStore from 'Core_Redux/store';

const ACK_STORAGE_KEY = 'has_seen_app_migration_notification';
const ALLOWED_NETWORK_IDS = [23100, 11001];
const DISPLAY_START_DATE = new Date('2025-11-07T00:00:00');

export class AppMigrationNotificationModalModuleStore extends Singleton implements IStateStore {
  private atomStore = getDefaultStore();
  private isOpenAtom;

  constructor() {
    super();
    this.isOpenAtom = atom(false);
  }

  public Use = () => {
    useAtom(this.isOpenAtom);
    return this;
  };

  public get IsOpen(): any {
    return this.atomStore.get(this.isOpenAtom);
  }

  public open() {
    this.atomStore.set(this.isOpenAtom, true);
  }

  public close() {
    this.atomStore.set(this.isOpenAtom, false);
    this.acknowledge();
  }

  private acknowledge() {
    localStorage.setItem(ACK_STORAGE_KEY, 'true');
  }

  private hasAcknowledged() {
    return JSON.parse(localStorage.getItem(ACK_STORAGE_KEY));
  }

  private isAllowedNetworkId(): boolean {
    const userState = reduxStore.store.getState().user;
    const primaryNetworkId = userState?.syncUser?.primaryNetworkId;

    if (!primaryNetworkId) {
      return false;
    }

    return ALLOWED_NETWORK_IDS.includes(primaryNetworkId);
  }

  private isWithinDateRange(): boolean {
    const now = new Date();
    // Display from 11/7/2025 onwards (no end date - networks will be added in tranches)
    return now >= DISPLAY_START_DATE;
  }

  public readyForDisplay(): boolean {
    return this.isAllowedNetworkId() && this.isWithinDateRange() && !this.hasAcknowledged();
  }
}
